import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.up_profile_assignments"))),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onDownload },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_download"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showModal(false, "create")
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(VDataTable, {
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.select_profile_assignments,
              "item-class": _vm.rowClassFlag,
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.flag_active",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.flag_active
                      ? _c(
                          VChip,
                          {
                            staticClass: "white--text",
                            attrs: { color: "green", small: "" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("table_ownership_history.states.active")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    !item.flag_active
                      ? _c(
                          VChip,
                          {
                            staticClass: "white--text",
                            attrs: { color: "warning", small: "" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "table_ownership_history.states.inactive"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (data) {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(data, "view")
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("crud.View")) +
                              " " +
                              _vm._s(_vm.$t("menu.dp.up_profile_assignments"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(data, "edit")
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-edit")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("crud.Edit")) +
                              " " +
                              _vm._s(_vm.$t("menu.dp.up_profile_assignments"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var attrs = ref.attrs
                                var on = ref.on
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onRenewConfirm(data)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("icon-renew"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("botones.boton_renew_assignment"))
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-firestore", {
        key: _vm.key_pagination,
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.cambiarPagina },
      }),
      _c("b-overlay", {
        attrs: { show: _vm.busy, "no-wrap": "", fixed: "" },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _vm.processing
                  ? _c(
                      "div",
                      [
                        _c("b-spinner", { attrs: { variant: "secondary" } }),
                        _c("p", [_vm._v(_vm._s(_vm.overlay_message) + " ...")]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        ref: "dialog",
                        staticClass: "text-center p-3",
                        attrs: {
                          tabindex: "-1",
                          role: "dialog",
                          "aria-modal": "false",
                          "aria-labelledby": "form-confirm-label",
                        },
                      },
                      [
                        _c("p", [
                          _c(
                            "strong",
                            { attrs: { id: "form-confirm-label" } },
                            [_vm._v("Are you sure?")]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  variant: "outline-danger",
                                  size: "sm",
                                },
                                on: { click: _vm.onCancelDelete },
                              },
                              [_vm._v("Cancel")]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-success",
                                  size: "sm",
                                },
                                on: { click: _vm.onConfirmDelete },
                              },
                              [_vm._v("OK")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DialogConfirmationComponent", {
        ref: "modal_confirm_renovar",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de realizar la acción?",
        },
        on: { onConfirm: _vm.onRenovarAsignacion },
      }),
      _c(
        "DialogsComponent",
        { ref: "dialog", attrs: { title: _vm.modalTitle, width: 800 } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [_vm._v(_vm._s(_vm.texts.user) + " :")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      rules: [
                                        function (v) {
                                          return !!v || "E-mail is required"
                                        },
                                        function (v) {
                                          return (
                                            /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                              v
                                            ) || "E-mail must be valid"
                                          )
                                        },
                                      ],
                                      dense: "",
                                      placeholder: "username@domain.com",
                                    },
                                    model: {
                                      value: _vm.record.user_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "user_name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "record.user_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [_vm._v(_vm._s(_vm.texts.position) + " :")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      rules: [
                                        function (v) {
                                          return !!v || "This field is required"
                                        },
                                      ],
                                      dense: "",
                                    },
                                    on: { keyup: _vm.uppercase },
                                    model: {
                                      value: _vm.record.user_position,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "user_position",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "record.user_position",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.texts.supervisor) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      rules: [
                                        function (v) {
                                          return !!v || "E-mail is required"
                                        },
                                        function (v) {
                                          return (
                                            /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                              v
                                            ) || "E-mail must be valid"
                                          )
                                        },
                                      ],
                                      dense: "",
                                      placeholder: "username@domain.com",
                                    },
                                    model: {
                                      value: _vm.record.supervisor_email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "supervisor_email",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "record.supervisor_email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("tablas.area")) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      dense: "",
                                      items: _vm.select_profile_areas,
                                      rules: [
                                        function (v) {
                                          return !!v || "This field is required"
                                        },
                                      ],
                                      value: _vm.record.area_id,
                                    },
                                    on: { change: _vm.changeArea },
                                    model: {
                                      value: _vm.record.area_id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.record, "area_id", $$v)
                                      },
                                      expression: "record.area_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("tablas.profile")) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      dense: "",
                                      items: _vm.profileFiltered,
                                      rules: [
                                        function (v) {
                                          return !!v || "This field is required"
                                        },
                                      ],
                                    },
                                    model: {
                                      value: _vm.record.userprofile_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "userprofile_id",
                                          $$v
                                        )
                                      },
                                      expression: "record.userprofile_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMonitoringInput,
                          expression: "showMonitoringInput",
                        },
                      ],
                      attrs: { dense: "" },
                    },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("frases.activo")) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VCheckbox, {
                                    attrs: {
                                      name: "checkbox-active",
                                      disabled: _vm.disable_check_active,
                                    },
                                    model: {
                                      value: _vm.record.flag_active,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.record, "flag_active", $$v)
                                      },
                                      expression: "record.flag_active",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMonitoringInput,
                          expression: "showMonitoringInput",
                        },
                      ],
                      staticClass: "border pt-2",
                      attrs: { dense: "" },
                    },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.texts.updated_by) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VTextField, {
                                    attrs: { disabled: true, size: "sm" },
                                    model: {
                                      value: _vm.record.creator_user,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "creator_user",
                                          $$v
                                        )
                                      },
                                      expression: "record.creator_user",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.texts.update_date) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      type: "datetime",
                                      disabled: true,
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.record.load_date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.record, "load_date", $$v)
                                      },
                                      expression: "record.load_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [_vm._v(_vm._s(_vm.texts.applicant) + " :")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VTextField, {
                                    attrs: { disabled: true, size: "sm" },
                                    model: {
                                      value: _vm.record.applicant_email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "applicant_email",
                                          $$v
                                        )
                                      },
                                      expression: "record.applicant_email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            VAlert,
                            {
                              attrs: {
                                value: _vm.alert,
                                dismissible: "",
                                color: "danger",
                                transition: "slide-y-transition",
                              },
                              on: { input: _vm.dismissible_close },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                              _c(VProgressLinear, {
                                attrs: { value: _vm.dismissCountDown },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.mode !== "view"
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "primary",
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _c(VIcon, [_vm._v("icon-send")]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }